import { useNavigate } from "@tanstack/react-router";
import { type FormEvent, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { m } from "@/paraglide/messages";
import { normalizeLetters } from "../lib/unscramble";

/**
 * Letters input → navigates to /word-unscrambler/$letters (results are rendered
 * server-side there). `normalizeLetters` is dictionary-free, so this stays a
 * lightweight client component.
 */
export function UnscrambleForm({ initial = "" }: { initial?: string }) {
  const navigate = useNavigate();
  const [value, setValue] = useState(initial);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const letters = normalizeLetters(value).slice(0, 12);
    if (letters.length < 2) return;
    navigate({ to: "/word-unscrambler/$letters", params: { letters } });
  };

  return (
    <form
      onSubmit={submit}
      className="pct-card space-y-3 rounded-2xl p-6 sm:p-8"
    >
      <Label htmlFor="unscramble-input" className="text-muted-foreground">
        {m.wu_input_label()}
      </Label>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Input
          id="unscramble-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={m.wu_input_placeholder()}
          maxLength={20}
          autoComplete="off"
          autoCapitalize="none"
          spellCheck={false}
          className="border-black/15 bg-white text-neutral-900 placeholder:text-neutral-500 dark:border-black/15 dark:bg-white dark:text-neutral-900 sm:flex-1"
        />
        <Button type="submit" size="lg">
          {m.wu_submit()}
        </Button>
      </div>
    </form>
  );
}
